import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Avatar, Typography, TextField, Button, Link, Grid, Paper } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { styled } from '@mui/material/styles';

import { postLogin } from '../../store/AuthSlice'


const LoginSection = styled('div')(({ theme }) => ({
    width: theme.spacing(50),
    height: theme.spacing(60),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: theme.spacing(5),
}))

const Root = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    width: '100%'
}))

const SignUpSection = styled('div')(({ theme }) => ({
    display: 'flex', 
    justifyContent: 'space-between',
    paddingTop: '0.5rem'
}))

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState();

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const isError = useSelector(state => state.auth.error);
    const isAuthenticated = useSelector(state => state.auth.token == null ? false : true);
    const authRedirectPath = useSelector(state => state.auth.authRedirectPath);

    const submitHandler = event => {
        event.preventDefault();
        const body = {
            email: email,
            password: password
        }
        dispatch(postLogin(body));
    }

    useEffect(()=>{
        if(isAuthenticated)
            navigate(authRedirectPath)
    },[isAuthenticated])

    return (
        <Root>
            <Paper sx={{ display: "flex", justifyContent: "center", width: '40rem', height: '30rem', marginTop: '10rem', }}>
                <LoginSection>
                    <Avatar sx={{ margin: '1rem' }}>
                        <LockOutlinedIcon color="primary"
                        />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Sign in
                    </Typography>
                    <form sx={{ width: '100%', marginTop: '1rem' }}
                        noValidate
                        onSubmit={submitHandler}
                    >
                        <TextField
                            error={isError}
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Email Address"
                            name="email"
                            autoComplete="email"
                            autoFocus
                            value={email}
                            onChange={event => setEmail((event.target.value))}
                            helperText={isError ? "Incorrect email" : ""}
                        />
                        <TextField
                            error={isError}
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Password"
                            type="password"
                            id="password"
                            autoComplete="current-password"
                            onChange={event => setPassword(event.target.value)}
                            helperText={isError ? "Incorrect password" : ""}
                        />
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            sx={{ margin: '1rem, 0 , 2rem', }}
                        >
                            Sign In
                        </Button>
                        <SignUpSection>
                                <Button size='small' sx={{fontSize: '0.7rem'}} variant='text' onClick={() => navigate('/password/reset')}>Forgot password?</Button>
                                <Button size='small' sx={{fontSize: '0.7rem'}} variant='text' onClick={() => navigate('/sign-up')}>"Don't have an account? Sign Up"</Button>
                        </SignUpSection>
                    </form>
                </LoginSection>
            </Paper>
        </Root>
    )
}

export default Login;